import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { authService, ForgotPasswordSubmitRequest } from '@aslanpay/portal-common-lib';

const useForgotPasswordSubmit = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, ForgotPasswordSubmitRequest>) => {
  return useMutation<unknown, Error, ForgotPasswordSubmitRequest>(
    ({ email, code, password }: ForgotPasswordSubmitRequest) =>
      authService.forgotPasswordSubmit({ email: email.toLowerCase(), code, password }),
    { onSuccess, onError }
  );
};

export default useForgotPasswordSubmit;
